import {DetailColumns, DetailPane, FormDialog} from '@management-ui/core';
import {Edit} from '@mui/icons-material';
import React, {useState} from 'react';
import Text from '../../../../components/Text';
import {formatCurrency} from '../../../../utilities';
import SalesOrderForm from '../../forms/SalesOrderForm';

const Delivery = ({order, onOrderUpdated}) => {
  const [fields, setFields] = useState('core');
  const [showForm, setShowForm] = useState(false);

  return (
    <>

      <DetailColumns columns={[

        <DetailPane
          title="Collection"
          actions={order.archived || order.locked ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('collection') || setShowForm(true)},
          ]}
          details={[
            {title: 'Collection Address', value: <Text text={order.collection_address ?? '-'}/>}
          ]}
        />,

        <DetailPane
          title="Delivery"
          actions={order.archived ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('delivery') || setShowForm(true)},
          ]}
          details={[
            {title: 'Delivery Address', value: <Text text={order.delivery_address ?? '-'}/>},
            {
              title: 'Delivery / Transport Cost',
              value: order.delivery_cost ? formatCurrency(order.delivery_cost, order.currency) : '-'
            },
            {title: 'Delivery Notes', value: <Text text={order.delivery_notes ?? '-'}/>},
          ]}
        />,
      ]}/>

      <FormDialog
        title="Edit Sales Order"
        open={showForm}
        onClose={() => setShowForm(false)}
        render={(props) => (
          <SalesOrderForm
            {...props}
            order={order}
            fields={fields}
            onSaved={(updated) => setShowForm(false) || onOrderUpdated(updated)}/>
        )}
      />

    </>
  );
}

export default Delivery;
